export default "__VITE_ASSET__DwdJs050__"